const initDeliveryInfo = () => {
  const deliveryTime = window.deliveryTime

  const deliveryWindow = [parseInt(deliveryTime.windowMin), parseInt(deliveryTime.windowMax)];
  const holidays = deliveryTime.holidays;
  const locale = deliveryTime.locale;

  const translations = {
    orderWithin: deliveryTime.orderWithinText,
    afterCutoff: deliveryTime.afterCutoffText
  }

  const [minDays, maxDays] = deliveryWindow || [1, 3];
  const cutoffHour = parseInt(deliveryTime.cutoffHour);
  let deliveryInfoEls = document.querySelectorAll('[data-delivery="text"]');
  const formatter = new Intl.DateTimeFormat(locale + '-DE', {
    day: 'numeric',
    month: 'long'
  });

  function isWeekend(date) {
    return date.getDay() === 0; // Sunday
  }

  function isHoliday(date) {
    const ymd = date.toISOString().slice(0, 10);
    return holidays.split(',').includes(ymd);
  }

  function addWorkingDays(date, days) {
    const result = new Date(date);
    let added = 0;
    while (added < days) {
      result.setDate(result.getDate() + 1);
      if (!isWeekend(result) && !isHoliday(result)) {
        added++;
      }
    }
    return result;
  }

  function getDeliveryRange(now, elementMinDays = minDays, elementMaxDays = maxDays) {
    const afterCutoff = now.getHours() >= cutoffHour;
    const baseDate = new Date(now);
    if (afterCutoff) baseDate.setDate(baseDate.getDate() + 1);

    const earliest = addWorkingDays(baseDate, elementMinDays);
    const latest = addWorkingDays(baseDate, elementMaxDays);

    return { earliest, latest, afterCutoff };
  }

  function getOrderCountdown(now) {
    const deadline = new Date(now);
    deadline.setHours(cutoffHour, 0, 0, 0);
    if (now.getHours() >= cutoffHour) return null;

    const diff = deadline - now;
    const hours = Math.floor(diff / (1000 * 60 * 60));
    const minutes = Math.floor((diff / (1000 * 60)) % 60);
    return { hours, minutes };
  }

  function updateDeliveryInfo() {
    const now = new Date();
    const countdown = getOrderCountdown(now);

    deliveryInfoEls.forEach(element => {
      const elementMinDays = parseInt(element.dataset.windowMin) || minDays;
      const elementMaxDays = parseInt(element.dataset.windowMax) || maxDays;

      const { earliest, latest, afterCutoff } = getDeliveryRange(now, elementMinDays, elementMaxDays);

      const startStr = formatter.format(earliest);
      const endStr = formatter.format(latest);

      if (countdown) {
        element.innerHTML =
          translations.orderWithin.replace('[h]', countdown.hours).replace('[m]', countdown.minutes).replace('[start]', startStr).replace('[end]', endStr)
      } else {
        element.innerHTML =
          translations.afterCutoff.replace('[start]', startStr).replace('[end]', endStr);
      }
    });

  }

  updateDeliveryInfo();
  setInterval(updateDeliveryInfo, 15000);

  document.addEventListener("liquify:product-sections-rendered", () => {
    deliveryInfoEls = document.querySelectorAll('[data-delivery="text"]');
    updateDeliveryInfo();
  })
}

initDeliveryInfo()